import React from 'react';
import { Dialog, DialogPanel, DialogTitle, Description } from '@headlessui/react';

export default function DialogHelper({ isOpen, onClose, title, message }) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-lg space-y-4 border border-gray-200 rounded-lg bg-white p-6 sm:p-8">
          <DialogTitle className="font-bold text-gray-900">{title}</DialogTitle>
          <Description className="text-gray-600">{message}</Description>
          <div className="flex gap-4 justify-end">
            <button onClick={onClose} className="btn-primary">Close</button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}



